var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxstat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 30V37C0 49.7025 10.2974 60 23 60H31.9508H40.9016C53.6041 60 63.9016 49.7025 63.9016 37V30.0148C63.9016 30.0099 63.9016 30.0049 63.9016 30C63.9016 29.9951 63.9016 29.9901 63.9016 29.9852V23C63.9016 10.2975 53.6041 0 40.9016 0H31.9508H23C10.2974 0 0 10.2975 0 23V30Z",
    fill: "#FEC53D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9756 24.3162L29.7149 31.7643C29.8629 31.8445 30.018 31.9024 30.1759 31.9392V46.3844L16.9555 39.0382C16.3481 38.7007 15.9756 38.0873 15.9756 37.4246V24.3162ZM47.9264 24.1182V37.4246C47.9264 38.0873 47.5539 38.7007 46.9465 39.0382L33.7261 46.3844V31.8126C33.7583 31.7975 33.7902 31.7814 33.8218 31.7643L47.9264 24.1182Z",
    fill: "#FEC53D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.499209,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4072 20.7014C16.575 20.5024 16.7869 20.3343 17.0338 20.2108L31.0123 13.2201C31.5991 12.9266 32.303 12.9266 32.8898 13.2201L46.8683 20.2108C47.0586 20.306 47.2281 20.4277 47.3727 20.5697L32.0468 28.8778C31.946 28.9325 31.8531 28.995 31.7684 29.064C31.6837 28.995 31.5908 28.9325 31.4901 28.8778L16.4072 20.7014Z",
    fill: "#FEC53D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxstat);
export default __webpack_public_path__ + "static/media/boxstat.440f383038b0c05b9483e736bc676651.svg";
export { ForwardRef as ReactComponent };